"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerOrAuthorizeUser = registerOrAuthorizeUser;
var _registerOrAuthorizeUser = require("../../repositories/users/v2/register-or-authorize-user");
var _transformRegisterOrAutorizeResonse = require("./transformRegisterOrAutorizeResonse");
function registerOrAuthorizeUser(httpApi, parameters) {
  return (0, _registerOrAuthorizeUser.fetchRegisterOrAuthorizeUser)({
    httpApi,
    parameters,
    mappers: {
      200: _transformRegisterOrAutorizeResonse.transform200,
      400: _transformRegisterOrAutorizeResonse.transform400
    },
    config: {
      requestConfig: {
        headers: [['Content-Type', 'application/json']],
        withCredentials: true
      }
    }
  });
}